var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-breadcrumbs',{attrs:{"items":_vm.breadcrumbItems}}),_c('v-card',[_c('v-data-table',{staticClass:"row-pointer",attrs:{"headers":_vm.headers,"items":_vm.clients,"footer-props":_vm.footerProps},on:{"click:row":_vm.displayDetails},scopedSlots:_vm._u([{key:"item.userId",fn:function(ref){
var item = ref.item;
return [_c('code',[_vm._v(_vm._s(_vm.userId(item)))])]}},{key:"item.name",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.userName(item))+" ")]}},{key:"item.email",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.userEmail(item))+" ")]}},{key:"item.socketId",fn:function(ref){
var item = ref.item;
return [_c('code',[_vm._v(_vm._s(_vm.socketId(item)))])]}},{key:"item.address",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.address(item))+" ")]}},{key:"item.transport",fn:function(ref){
var item = ref.item;
return [(item.sockets.length)?_c('Transport',{attrs:{"transport":item.sockets[0].transport}}):_vm._e()]}},{key:"item.sockets",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.sockets.length)+" ")]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [(_vm.isSocketDisconnectSupported)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"ml-3",attrs:{"disabled":_vm.isReadonly,"small":""},on:{"click":function($event){$event.stopPropagation();return _vm.disconnect(item)}}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("mdi-logout")])],1)]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.$t("clients.disconnect")))])]):_vm._e()]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }